// extracted by mini-css-extract-plugin
module.exports = {"sticky-container":"styles_sticky-container__4mjwg","content":"styles_content__1_dCt","skeleton-animation":"styles_skeleton-animation__GG3xk"};